export const getDefaultValueFromPermissions = (
  permissions: number[],
  values: number[] | undefined
): number | undefined => {
  if (!values) {
    return;
  }

  const valuesFiltered = permissions?.filter(permission =>
    values.includes(permission)
  );

  return valuesFiltered?.[0];
};
